<template>
	<div class="insert-data">
		<c-button v-if="scanName && (testData || scanAuth)" class="insert-data-scan" color="main" hollow prepend-icon="tf-scan" @click="scanHandle">{{scanName}}</c-button>
		<div v-if="buttons && buttons.length" class="insert-data-button flex-between-center">
			<c-link v-for="(item, i) in buttons" :key="i" color="main" icon="tf-add" @click="clickHandle(i)">{{item}}</c-link>
		</div>
	</div>
</template>

<script>
	import {mapGetters} from 'vuex'
	import {getStore, mapStore} from '@deanwu/vue-component-library-mobile'

	export default {
		name: 'insertData',

		props: {
			scanName: String,
			buttonName: [String, Array],
			testData: [String, Object]
		},
		
		data() {
			return {
				...getStore(this, 'cFormItemStore')
			}
		},

		computed: {
			...mapGetters(['scanAuth']),
			...mapStore('cFormItemStore', ['warnState']),

			buttons() {
				return typeof this.buttonName == 'string' ? [this.buttonName] : this.buttonName;
			}
		},
		
		methods: {
			scanHandle() {
				let stop = false;
				this.$emit('beforeScan', () => {
					stop = true;
				});
				if (!stop) {
					if (this.testData) {
						this.cFormItemStore && this.cFormItemStore.commit('warnState', false);
						this.$emit('scan', this.testData);
						return;
					}
					this.scanCode({
						success: data => {
							this.cFormItemStore && this.cFormItemStore.commit('warnState', false);
							this.$emit('scan', data);
						}
					});
				}
			},

			clickHandle(i) {
				this.cFormItemStore && this.cFormItemStore.commit('warnState', false);
				this.$emit('click', i);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.insert-data {
		&-scan {
			width: 100%;
			height: .88rem !important;
			font-size: .36rem !important;
		}

		&-button {
			height: 1rem;
			font-size: .32rem;
		}

		+ >>> .c-card {
			margin-top: .3rem;
		}
	}
</style>
